module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_59.65a3874a.jpg";